import React, { useState, useEffect } from 'react';
import Logo from '../assets/nextcastle-logo.png';
import Hamburger from '../assets/ham.svg';
import Close from '../assets/close.svg';
import { Link } from 'react-router-dom';
import '../styles/nav.css';

function Nav() {
    const [showNav, setShowNav] = useState(false);
    const [activeLink, setActiveLink] = useState(1);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    const navToggler = () => setShowNav(!showNav);
    const removeNav = (index) => {
        setShowNav(false);
        setActiveLink(index);
    };
  
    const toggleDropdown = () => {
        if (isMobile) {
            setShowDropdown(!showDropdown);
        }
    };
  
    return (
        <div className='nav-container'>
            <div className="logo">
                <Link to='/'>
                    <img onClick={() => removeNav(1)} src={Logo} alt="nextcastle-logo" />
                </Link>
            </div>
            <div className="hamburger">
                {!showNav && <img onClick={navToggler} src={Hamburger} alt="hamburger" />}
                {showNav && <img onClick={navToggler} className='nav-close' src={Close} alt="close" />}
            </div>
            <div className={showNav ? 'mobile-view' : 'desktop-view'}>
                <Link className={activeLink === 1 ? 'active-link' : ''} onClick={() => removeNav(1)} to='/'>Home</Link>
                <div className='services'
                    onMouseOver={() => !isMobile && setShowDropdown(true)}
                    onMouseOut={() => !isMobile && setShowDropdown(false)}
                    onClick={toggleDropdown}>
                    Services
                    {showDropdown && (
                        <span>
                            <div className="service-links">
                                <Link to='/Procurement'>Procurement</Link>
                                <Link to='/Construction'>Construction</Link>
                                <Link to='/Engineering'>Engineering</Link>
                                <Link to='/Corrosion'>Corrosion Control</Link>
                                <Link to='/Contracting'>Contracting</Link>
                            </div>
                        </span>
                    )}
                </div>
                <Link className={activeLink === 3 ? 'active-link' : ''} onClick={() => removeNav(3)} to='/Projects'>Projects</Link>
                {/* <Link className={activeLink === 4 ? 'active-link' : ''} onClick={() => removeNav(4)} to='/News'>News</Link> */}
                <Link className={activeLink === 5 ? 'active-link' : ''} onClick={() => removeNav(5)} to='/Contact'>Contact Us</Link>
            </div>
        </div>
    );
}

export default Nav;
